module.exports = __webpack_public_path__ + "img/banking.c2adaf4a.svg";